import {AvailableMassivePatchesInfo, MassiveActions} from "../MassiveActionsTypesAndFunctions";
import * as React from "react";
import {useNavigate} from "react-router-dom";
import {DATA_STATE} from "../../../users/contexts/UsersDashboardContext";
import {Display} from "../../../components/Display";
import {Loader} from "../../../components/Utils/loader/Loader";

export interface RedirectPageProps {
    massiveAction: MassiveActions
    availableMassivePatchesInfo: AvailableMassivePatchesInfo
}

const DEFERED_PATHS = [
    MassiveActions.PACKAGES_CLAIM,
    MassiveActions.EQUIPMENT_DELETION,
    MassiveActions.LOCATIONS_DELETION
];

export const RedirectPage: React.FC<RedirectPageProps> = ({massiveAction, availableMassivePatchesInfo}) => {
    const navigate = useNavigate();

    const {availableMassiveState, availableMassivePatches} = availableMassivePatchesInfo;

    React.useEffect(() => {
        if (massiveAction && availableMassiveState === DATA_STATE.loaded && availableMassivePatches.length > 0) {
            const patch = availableMassivePatches.find(
                availablePatch => availablePatch.name === massiveAction && availablePatch.available);

            if (patch !== undefined || DEFERED_PATHS.includes(massiveAction)) {
                navigate(`/${massiveAction}`);
            } else {
                navigate('/massiveActionNotAvailable')
            }
        }
    }, [massiveAction, availableMassiveState, availableMassivePatches.length]);
    return (
        <Display isVisible={availableMassiveState === DATA_STATE.isLoading || availableMassivePatches.length === 0}>
            <div className={"wrapper"}>
                <Loader/>
            </div>
        </Display>
    )
}